import React, { useEffect, useState } from 'react';
import {
	Alert,
	CircularProgress,
	IconButton,
	Tooltip,
	Typography,
} from '@mui/material';
import { getTickets } from '../../actions/tickets';
import { handleError, handleSuccess, rowStyle } from '../../helpers/utils';
import InfoIcon from '@mui/icons-material/Info';
import { DataGrid, esES } from '@mui/x-data-grid';
import Label from '../utils/Label';
import {
	sortByTimestamp,
	timestampToNormalDateTime,
} from '../../helpers/hours';
import { useNavigate } from 'react-router-dom';

export const TicketsCatalog = () => {
	// Loading state
	const [isLoading, setLoading] = useState(false);

	// Columns
	const [rows, setRows] = useState([]);

	const navigate = useNavigate();

	const fetchTickets = () => {
		setLoading(true);

		getTickets()
			.then((snapshot) => {
				let data = [];
				snapshot.forEach((doc) => {
					data.push({
						id: doc.id,
						...doc.data(),
					});
				});
				setRows(sortByTimestamp(data));
			})
			.catch((error) => {
				handleError(error, 'Error al obtener los tickets.');
			})
			.finally(() => {
				// Remove loading state
				setLoading(false);
			});
	};

	useEffect(() => {
		fetchTickets();
	}, []);

	// Define columns
	const columns = [
		{
			field: 'col11',
			...columnStyleCell,
			headerName: 'Acciones',
			width: 80,
			// Add actions to each case
			renderCell: ({ row }) => (
				<Tooltip title='Ver'>
					<IconButton
						style={{ color: '#143f6c' }}
						aria-label='profile'
						color='primary'
						onClick={() => {
							const path = `/dashboard/ticket/${row.id}`;
							localStorage.setItem('lastPathPilu', path);
							navigate(path);
						}}
					>
						<InfoIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			field: 'title',
			...columnStyleCell,
			headerName: 'Título',
			width: 250,
			renderCell: ({ row }) => (
				<Tooltip title={row.title}>
					<span className='table-cell-trucate'>{row.title}</span>
				</Tooltip>
			),
		},
		{
			field: 'type',
			...columnStyleCell,
			headerName: 'Tipo',
			width: 100,
			renderCell: ({ row }) => (
				<Label color={row.type === 'error' ? 'error' : 'success'}>
					{row.type}
				</Label>
			),
		},
		{
			field: 'status',
			...columnStyleCell,
			headerName: 'Estatus',
			width: 100,
			renderCell: ({ row }) => (
				<Label
					color={
						row.status === 'Reportado'
							? 'error'
							: row.status === 'Rechazado'
							? 'warning'
							: row.status === 'En proceso'
							? 'info'
							: row.status === 'Finalizado'
							? 'success'
							: row.status === 'Cancelado'
							? 'secondary'
							: 'default'
					}
				>
					{row.status}
				</Label>
			),
			valueGetter: ({ row }) => row.status,
		},
		{
			field: 'description',
			...columnStyleCell,
			headerName: 'Descripción',
			width: 300,
			renderCell: ({ row }) => (
				<Tooltip title={row?.description}>
					<span className='table-cell-trucate'>
						{row?.description}
					</span>
				</Tooltip>
			),
		},
		{
			field: 'created',
			...columnStyleCell,
			headerName: 'Fecha de creación',
			width: 160,
			renderCell: ({ row }) => (
				<Tooltip title={timestampToNormalDateTime(row.created)}>
					<span className='table-cell-trucate'>
						{timestampToNormalDateTime(row.created)}
					</span>
				</Tooltip>
			),
		},
	];

	// Column style
	const columnStyleCell = {
		headerClassName: 'column-header-pilu',
		headerAlign: 'center',
	};

	return (
		<div
			style={{
				padding: '20px',
			}}
		>
			{/* REQUESTS */}
			<Typography
				variant='h4'
				gutterBottom
				style={{ ...rowStyle, margin: '20px 0 10px 0' }}
			>
				Tickets
			</Typography>

			{isLoading ? (
				<center style={{ padding: '20%' }}>
					<CircularProgress />
				</center>
			) : (
				<>
					{/* Datagrid table */}
					{rows?.length > 0 ? (
						<div>
							<DataGrid
								rows={rows}
								columns={columns}
								density='compact'
								autoHeight
								localeText={
									esES.components.MuiDataGrid.defaultProps
										.localeText
								}
							/>
						</div>
					) : (
						<div style={{ margin: '30px 0' }}>
							<Alert severity='info'>No hay ningún ticket</Alert>
						</div>
					)}
				</>
			)}
		</div>
	);
};
